module.exports = __webpack_public_path__ + "img/ico-umbrella-blue.268f0c2b.svg";